export default __webpack_public_path__ + "static/media/q24_step1.622c3c2e.png";